import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, Inject, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDatepicker } from '@angular/material/datepicker';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/core/services/auth.service';
import { ConfirmDialogComponent } from 'src/app/shared/confirm-dialog/confirm-dialog.component';

@Component({
    selector: 'app-allergy',
    templateUrl: './allergy.component.html',
    styleUrls: ['./allergy.component.css'],
    standalone: false
})
export class AllergyComponent implements OnInit {
  selected: string = '';
  medlist: any[] = [];
  allergReactions: any[] = [];
  insuranceList: any[] = [];
  allergyList: any[] = [];
  immunizationList: any[] = [];
  medconList:any[]=[];
  famHistoryList:any[]=[];
  searchText: string = '';
  titleMap: { [key: string]: string } = {
    familyhistory: 'Family History',
    medicalcondition: 'Medical Condition'
  };

  constructor(
    private router: Router,
    private route : ActivatedRoute,
    private authService: AuthService,
    private toastr: ToastrService,
    private dialog: MatDialog,
  ) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe((params:any) => {
      this.selected = params.get('type') || '';
      //console.log('Selected type from route:', this.selected);
    });
  
    
    this.loadProfileDetails();
  }

  get headerTitle(): string {
  const titles: { [key: string]: string } = {
    allergy: 'Allergy',
    insurance: 'Insurance',
    immunization: 'Immunization',
    familyhistory: 'Family History',
    medicalcondition: 'Medical Conditions',
  };
  return titles[this.selected] || 'List Of Medications';
}

   get filteredList(): any[] {
    const listMap: { [key: string]: any[] } = {
      insurance: this.insuranceList,
      allergy: this.allergyList,
      immunization: this.immunizationList,
      medicalcondition: this.medconList,
      familyhistory: this.famHistoryList
    };

    const currentList = listMap[this.selected] || [];

    if (!this.searchText?.trim()) return currentList;

    const search = this.searchText.toLowerCase();
    return currentList.filter(item =>
      Object.values(item).some(value =>
        String(value).toLowerCase().includes(search)
      )
    );
  }

  convertDateFormat(dateString: string): string {
    if (!dateString) return '';
    
    const [month, day, year] = dateString.split('-');
    return `${day}-${month}-${year}`;
  }

  /** Loads user profile data and maps to the respective selected tab. */
  private loadProfileDetails(): void {
    if (!this.selected) return;

    this.authService.profile_details_cat(this.selected).subscribe({
      next: (res: any) => {
        const data = res?.data;
        // console.log('data',data)

        switch (this.selected) {
          case 'insurance':
            this.insuranceList = data?.insurance.reverse() || [];
            break;
          case 'allergy':
            this.allergyList = data?.allergy.reverse() || [];
            break;
          case 'immunization':
            this.immunizationList = data?.immunization.reverse() || [];
            break;
          case 'medicalcondition':
            this.medconList = data?.medicalCondition.reverse() || [];
            break;
          case 'familyhistory':
            this.famHistoryList = data?.familyHistory.reverse() || [];
            break;
            
          default:
            break;
        }
      },
      error: () => this.toastr.error('Failed to load profile details')
    });
  }

  logIcons: any = {
    insurance: 'assets/images/health/icons/insurance ico1.svg',
    familyhistory: 'assets/images/health/healthlogico/familyhispng.png',
    medicalcondition: 'assets/images/health/icons/med-rep.png',
    allergy: 'assets/images/health/icons/allergies 1(1).svg',
    immunization: 'assets/images/health/healthlogico/immunization.png'
  };

  getLogTitle(selected: any) {
    const titles: any = {
      insurance: 'Insurance',
      familyhistory: 'Family History',
      medicalcondition: 'Medical Condition',
      allergy: 'Allergy',
      immunization: 'Immunizations'
    };
    return titles[selected] || '';
  }

  getBtnTitle(selected: string): string {
    const titles: any = {
      insurance: 'Insurance',
      familyhistory: 'Family History',
      medicalcondition: 'Medical Condition',
      allergy: 'Allergy',
      immunization: 'Immunization'
    };
    return titles[selected] || '';
  }



//   getLogTitle(selected: string): string {
//   return this.titleMap[selected] || (selected ? selected.charAt(0).toUpperCase() + selected.slice(1) : '');
// }

  /** Opens dialog to add new entry (logic can be added here later). */
  
     openDialog(){
        const dialogRef = this.dialog.open(AllergyDialogComponent, {
          width: '500px',
          height: '500px',
          data: { 
            mode: 'add',
            selected:this.selected
          },
          disableClose: true,
          autoFocus: true,
        
        });
    
        dialogRef.afterClosed().subscribe(result => {
          if (result) {
           this.loadProfileDetails();
          }
        });
       }
  

  /** Placeholder for edit logic. */
  onEdit(data: any): void {
    const dialogRef = this.dialog.open(AllergyDialogComponent, {
          width: '500px',
          height: '500px',
          data: { 
            mode: 'edit',
            details:data,
            selected:this.selected
          },
          disableClose: true,
          autoFocus: true,
        
        });
    
        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            this.loadProfileDetails();
          }
        });
  }

  /** Placeholder for delete logic. */
  // onDelete(data: any): void {
  //   if(data){
  //      this.authService.del_profile_details_cat(this.selected,data.id).subscribe((res:any)=>{
  //     if(res){
  //       this.loadProfileDetails();
  //     }
  //   })
  //   }
  // }

  onDelete(med: any) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '400px',
      data: {
        title: `Delete ${this.selected}`,
        message: `Are you sure want to delete this ${this.headerTitle}?`,
        sub: 'You will not be able to recover it once it is deleted.'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && med) {
        this.authService.del_profile_details_cat(this.selected, med.id).subscribe(
          (res: any) => {
            // Remove from local list
            this.loadProfileDetails();
            this.toastr.success(res.msg);
          },
          (error: any) => {
            //console.error('Error deleting medication:', error);
            this.toastr.error('Failed to delete medication');
          }
        );
      }
    });
  }

  goBack(): void {
    this.router.navigate(["/health/dashbord"])
  }
}
import { NativeDateAdapter, DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MAT_NATIVE_DATE_FORMATS } from '@angular/material/core';
import { es } from 'date-fns/locale';
import { Platform } from '@angular/cdk/platform';

export class YearOnlyDateAdapter extends NativeDateAdapter {
  override parse(value: any): Date | null {
    if (value == null) return null;
    if (typeof value === 'number' && value >= 0) return new Date(value, 0, 1);
    if (value instanceof Date) return new Date(value.getFullYear(), 0, 1);
    if (typeof value === 'string') {
      const m = value.trim().match(/^(\d{4})$/); // accept only YYYY
      if (m) return new Date(+m[1], 0, 1);
    }
    return null; // reject anything that isn't just YYYY
  }

  override format(date: Date, displayFormat: string): string {
    // Always display as YYYY
    return String(date.getFullYear());
  }
}

export const YEAR_ONLY_FORMATS = {
  parse: { dateInput: 'YYYY' },
  display: {
    dateInput: 'YYYY',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'YYYY',
    monthYearA11yLabel: 'YYYY',
  },
};


@Component({
    selector: 'app-allergy-dialog',
    templateUrl: './dialog-allergy-box.html',
    styleUrls: ['./allergy.component.css'],
    providers: [
        // Choose adapter at runtime based on dialog data
        {
            provide: DateAdapter,
            deps: [MAT_DATE_LOCALE, Platform, MAT_DIALOG_DATA],
            useFactory: (locale: string, platform: Platform, data: {
                selected: string;
            }) => {
                return data?.selected === 'medicalcondition';
            }
        },
        // Choose date formats to match the adapter
        {
            provide: MAT_DATE_FORMATS,
            deps: [MAT_DIALOG_DATA],
            useFactory: (data: {
                selected: string;
            }) => {
                return data?.selected === 'medicalcondition'
                    ? YEAR_ONLY_FORMATS
                    : MAT_NATIVE_DATE_FORMATS;
            }
        },
        { provide: MAT_DATE_LOCALE, useValue: 'en-US' }
    ],
    standalone: false
})
export class AllergyDialogComponent {
  myForm: FormGroup;
  dialogMode: string;
  selected_dialog_mode:any;
  allergReactions:any[]=[];
  medlist:any[]=[];
  immunization:any[]=[];
  fam_historty_list = ["mother","father","son", "daughter","friend","others"];
  filteredConditions: any[] = [];
  currentYear = new Date().getFullYear();
  today = new Date();
  maxDate = new Date();
  tomorrow =  new Date(this.maxDate.setDate(this.maxDate.getDate()+1));
  submitted = false;
  selyear = new Date();
  minyear = new Date(1990,1,1)

  constructor(
    private formBuilder: FormBuilder,
    private dialogRef: MatDialogRef<AllergyDialogComponent>,
    public auth: AuthService,
    private toastr: ToastrService,
    private datePipe: DatePipe,
    private cdr: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public data:{mode: 'add' | 'edit',selected:any,details?: any}
  ) {
    this.dialogMode = data.mode;
    this.selected_dialog_mode = data.selected;
    // console.log(data)
    this.myForm = this.initForm(this.selected_dialog_mode, data.details || {});
  }

  ngOnInit(): void {
  this.getMedicalConditions();
  this.myForm.get('conditionName')?.valueChanges.subscribe(value => {
    const filterValue = value?.toLowerCase() || '';
    this.filteredConditions = this.medlist?.filter((condition:any) =>
      condition.title.toLowerCase().includes(filterValue)
    );
  });
  if(this.selected_dialog_mode==='medicalcondition' && this.dialogMode==='add'){
    const year = this.selyear.getFullYear();
    this.myForm.get('yearOfDiagnosis')?.setValue(year);
  }

}

  getError(controlName: string): string | null {
      const control = this.myForm.get(controlName);

      if (!control || !control.errors || !control.touched) {
        return null; // only show errors when touched
      }

      if (control.errors['required']) {
        return 'This field is required';
      }

      if (control.errors['minlength']) {
        const requiredLength = control.errors['minlength'].requiredLength;
        return `Minimum length is ${requiredLength}`;
      }

      if (control.errors['maxlength']) {
        const requiredLength = control.errors['maxlength'].requiredLength;
        return `Maximum length is ${requiredLength}`;
      }

      if (control.errors['min']) {
        return `Minimum value is ${control.errors['min'].min}`;
      }

      if (control.errors['max']) {
        return `Maximum value is ${control.errors['max'].max}`;
      }

      if (control.errors['pattern']) {
        return 'Invalid format';
      }

      return null;
    }

  private initForm(type: any, details: any): FormGroup {
    switch (type) {
      case 'medicalcondition':
        this.getMedicalConditions();
        return this.formBuilder.group({
          conditionName: [details.conditionName || '', Validators.required],
          yearOfDiagnosis: [details?.yearOfDiagnosis
                              ? this.toYear(details.yearOfDiagnosis)
                              : this.selyear,
                               [Validators.required, 
                                Validators.min(1900),
                                Validators.max(this.currentYear)]],
          comment: [details.comment || '']
        });

      case 'allergy':
        this.getAllergicReactions();
        return this.formBuilder.group({
          allergicTo: [details.allergicTo || '', Validators.required],
          allergicReaction: [details.allergicReaction || [], Validators.required],
          severity: [details.severity?.toLowerCase() || '', Validators.required],
          comment: [details.comment || '']
        });

      case 'familyhistory':
        this.getMedicalConditions();
        return this.formBuilder.group({
          conditionName: [details.conditionName || '', Validators.required],
          relationship: [details.relationship || '', Validators.required],
          comment: [details.comment || '']
        });

      case 'insurance':
        return this.formBuilder.group({
          insuranceCompany: [details.insuranceCompany || '', Validators.required],
          policyNumber: [details.policyNumber || '', Validators.required],
          memberId: [details.memberId || ''],
          groupNumber: [details.groupNumber || ''],
          // startDate: [details.startDate? new Date(details.startDate) :''],
          // endDate: [details.endDate? new Date(details?.endDate):''],
          startDate: [details?.startDate ? new Date(details?.startDate) : ''],
          endDate: [details?.endDate ? new Date(details?.endDate) : ''],
          planName: [details.planName || '', Validators.required],
          status: [details?.status ? details.status.toLowerCase() : '', Validators.required],
          comment: [details.comment || '']
        });

      case 'immunization':
        this.getImmunization();
        return this.formBuilder.group({
          vaccineName: [details.vaccineName || '', Validators.required],
          adminDate: [details.adminDate ? new Date(details.adminDate)  :'', Validators.required],
          nextDueDate: [details.nextDueDate ? new Date(details.nextDueDate):  ''],
          detail: [details.detail || '']
        });

      default:
        return this.formBuilder.group({});
    }
  }

      private toYear(value: any): any {
      if (!value) return null;
      if (value instanceof Date){
         this.selyear = new Date(value.getFullYear(), 0, 1);
      } else if (typeof value === 'number' && value >= 0) {
        this.selyear = new Date(value, 0, 1);
      }
      return this.selyear;

    }


  getAllergicReactions(): void {
    this.auth.get_allergic_reaction().subscribe({
      next: (res: any) => {
        this.allergReactions = res?.data.allergy || [];
      },
      error: () => this.toastr.error('Failed to load allergic reactions')
    });
  }
  getMedicalConditions() {
    this.auth.get_medical_condition().subscribe({
      next: (res: any) => {
        this.medlist = res?.data?.medicalcondition || [];
        //console.log(this.medlist)
      },
      error: () => this.toastr.error('Failed to load medical conditions')
    });
  }
    
  getImmunization(){
    this.auth.get_vaccine_list().subscribe((res:any)=>{
      if(res){
        this.immunization = res.data.vaccine
      }
    })
    
  }

    selectYear(date: Date, datepicker: any) {
    const year = date.getFullYear();
    this.selyear = new Date(year, 0, 1);
    this.myForm.get('yearOfDiagnosis')?.setValue(year);
    console.log(this.myForm.value.yearOfDiagnosis)
    datepicker.close();
  }

  onSubmit(): void {
    this.submitted = true
    if (this.myForm.invalid) {
      this.myForm.markAllAsTouched();
      return;
    }
   //check if year of diagnosis is date format or a year number
   if (this.selected_dialog_mode==='medicalcondition' &&this.myForm.value.yearOfDiagnosis instanceof Date) {
     this.myForm.value.yearOfDiagnosis = this.myForm.value.yearOfDiagnosis.getFullYear();
   }

    
    
     

     //converts all date to the MM-DD-YYYY
     const formattedFormValue = { ...this.myForm.value };

      for (const key in formattedFormValue) {
        const value = formattedFormValue[key];
        if (value instanceof Date) {
          formattedFormValue[key] = this.datePipe.transform(value, 'MM-dd-yyyy');
        }
      }
      //console.log(formattedFormValue)
    if(this.dialogMode==='add'){
      this.auth.add_profile_details_cat(this.selected_dialog_mode,formattedFormValue).subscribe((res:any)=>{
      if(res){
        this.toastr.success(res.msg)
        this.dialogRef.close(formattedFormValue);
      }
    })

    } else {
      this.auth.update_profile_details_cat(this.selected_dialog_mode,this.data.details.id,formattedFormValue).subscribe((res:any)=>{
      if(res){
        this.toastr.success(res.msg)
        this.dialogRef.close(formattedFormValue);
      }
    })
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }
  end_min_value(start: Date) {
  if (start) {
    const sdate = new Date(start);
    sdate.setDate(sdate.getDate() + 1); // add 1 day
    return sdate;
  }
  return this.tomorrow;
}


  getDialogTitle(mode: string): string {
    switch (mode) {
      case 'familyhistory':
        return 'Family History';
      case 'medicalcondition':
        return 'Medical Condition';
      default:
        // fallback: capitalize first letter of each word
        return mode.replace(/([a-z])([A-Z])/g, '$1 $2') // handles camelCase
          .replace(/_/g, ' ')                 // handles snake_case
          .replace(/\b\w/g, char => char.toUpperCase());
    }
  }

}
